export const featuresTableData = [
  {
    category: "AI Content Engine",
    features: [
      {
        name: "Ad Copy Generator",
        free: "Basic",
        starter: "Advanced",
        pro: true,
        business: true,
      },
      {
        name: "Blogs & Articles",
        free: false,
        starter: "Limited",
        pro: true,
        business: true,
      },
      {
        name: "Hooks & Angles Generator",
        free: "3 / month",
        starter: true,
        pro: true,
        business: true,
      },
      {
        name: "Humanization",
        free: false,
        starter: false,
        pro: true,
        business: true,
      },
    ],
  },

  {
    category: "Creative Generation",
    features: [
      {
        name: "Image Generation",
        free: "3 / month",
        starter: "30 / month",
        pro: "100 / month",
        business: "Unlimited",
      },
      {
        name: "Video Generation",
        free: false,
        starter: "5 / month",
        pro: "20 / month",
        business: "Unlimited",
      },
      {
        name: "Smart Resizing",
        free: false,
        starter: true,
        pro: true,
        business: true,
      },
    ],
  },

  {
    category: "Ad Automation",
    features: [
      {
        name: "Ad Templates",
        free: "Basic",
        starter: "Standard",
        pro: "Full Library",
        business: true,
      },
      {
        name: "Ad Variations (A/B Testing)",
        free: false,
        starter: "Limited",
        pro: true,
        business: true,
      },
      {
        name: "Bulk Ad Maker",
        free: false,
        starter: false,
        pro: "Up to 50",
        business: "Unlimited",
      },
      {
        name: "Live Ads",
        free: false,
        starter: false,
        pro: true,
        business: true,
      },
      {
        name: "Ad Library",
        free: "Basic",
        starter: true,
        pro: true,
        business: true,
      },
    ],
  },

  {
    category: "Analytics & Insights",
    features: [
      {
        name: "Creative Analysis",
        free: false,
        starter: false,
        pro: true,
        business: true,
      },
      {
        name: "Predictive Analysis",
        free: false,
        starter: false,
        pro: true,
        business: true,
      },
      {
        name: "Performance Insights",
        free: "Basic Stats",
        starter: "Standard",
        pro: "Advanced",
        business: "Pro-Level",
      },
      {
        name: "AI Recommendations",
        free: false,
        starter: false,
        pro: true,
        business: true,
      },
    ],
  },

  {
    category: "Brand & Workspace",
    features: [
      {
        name: "Brand Kits",
        free: false,
        starter: "1 Kit",
        pro: "5 Kits",
        business: "Unlimited",
      },
      {
        name: "Workspace Access",
        free: "1 Workspace",
        starter: "1 Workspace",
        pro: "3 Workspaces",
        business: "Unlimited",
      },
      {
        name: "Whiteboard",
        free: false,
        starter: false,
        pro: true,
        business: true,
      },
      {
        name: "Workspace Add-ons",
        free: false,
        starter: false,
        pro: true,
        business: true,
      },
    ],
  },

  {
    category: "Team & Collaboration",
    features: [
      {
        name: "Team Members",
        free: "1 (Solo)",
        starter: "Up to 3",
        pro: "Up to 10",
        business: "Unlimited",
      },
      {
        name: "Role-based Access",
        free: false,
        starter: false,
        pro: true,
        business: true,
      },
    ],
  },

  {
    category: "Integrations",
    features: [
      {
        name: "Facebook Ads Integration",
        free: false,
        starter: false,
        pro: true,
        business: true,
      },
      {
        name: "Multi-account Support",
        free: false,
        starter: false,
        pro: true,
        business: true,
      },
    ],
  },

  {
    category: "Usage & Limits",
    features: [
      {
        name: "Monthly AI Credits",
        free: "100 credits / mo",
        starter: "5,000 credits / mo",
        pro: "25,000 credits / mo",
        business: "Custom volume pricing",
      },
      {
        name: "Support",
        free: "Community",
        starter: "Standard",
        pro: "Priority",
        business: "Dedicated",
      },
    ],
  },
];
